<script>
import 'animate.css'
import { WOW } from 'wowjs'
export default {
	props: {

	},
  data() {
    return {
      list: [
        {
          img: require('@assets/images/home/illustration01.svg'),
          title: '轉型數位化',
          content: '為你的服務創造真實收益',
        },
        {
          img: require('@assets/images/home/illustration02.svg'),
          title: '多元式預約',
          content: '客戶輕鬆預約，體驗大加分',
        },
        {
          img: require('@assets/images/home/illustration03.svg'),
          title: '營運與管理',
          content: '了解經營狀況，有效管理',
        },
        {
          img: require('@assets/images/home/illustration04.svg'),
          title: '會員與寵物管理',
          content: '輕鬆管理資料，創造回客率與新客體驗',
        },
      ],
    }
  }
}
</script>

<template>
  <div :class="$style.sectionCloud">
    <div class="section pt-0">
      <div class="container">
        <BaseSectionTitle 
          title="愛寵訂的四大優勢" 
          sub-title="Get it to try!" 
          class="isStyleDecoration text-center isCenter mx-auto wow animate__animated animate__fadeInUp"
        />
        <div class="row justify-content-center sectionCloud__list item1 wow animate__animated animate__fadeInUp">
          <div
            v-for="(item, $index) in list"
            :key="$index"
            class="col-lg-3 col-6 sectionCloud__item"
          >
            <img class="sectionCloud__img" :src="item.img" alt="">
            <h3 class="fs-4 text-center sectionCloud__title">{{item.title}}</h3>
            <p class="text-center color-text-2">{{item.content}}</p>
            <!-- <div class="mt-5">
              <div class="row">
                <div v-for="(brandItem, $index2) in item.brand"  :key="$index2" class="col-6">
                  <img :src="brandItem" alt="">
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <BaseBlock
          title="讓你的寵物服務，不再忙碌了一整天<br>卻無法創造收益！"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionCloud {
  position: relative;
  @media screen and (max-width: 1700px) {
    padding-top: 5rem;
  }
  @media screen and (max-width: 1400px) {
    padding-top: 0;
    margin-top: -3rem;
  }
  @include max-sm {
    margin-top: 0;
  }
  &:before {
    content: "";
    position: absolute;
    bottom: 3%;
    background-image: url('@assets/images/home/advantage.svg');
    padding-bottom: 39%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100vw;
    left: 0;
    @include max-xl {
      bottom: 24%;
      // background-position: 10%;
    }
    @include max-md {
      bottom: 0;
      top: 0;
    }
  }
  :global {
    .sectionCloud {
      &__list {

      }
      &__item {
        text-align: center;
      }
      &__img {
        width: 255px;
        height: 195px;
        margin: 0 auto;
      }
      &__title {
        margin-top: 3rem;
      }
      &__bottomBox {
        width: 1028px;
        max-width: 100%;
        // margin-top: 50px;
        padding-left: 100px;
        padding-right: 100px;
        position: relative;
        text-align: center;
        margin: 60px auto 0;
        @include max-lg {
          padding-left: 10px;
          padding-right: 10px;
          margin: 40px auto 0;
        }
        &:before {
          content: url('~@assets/images/home/section6-paw-left.svg');
          position: absolute;
          left: 50px;
          bottom: 40px;
          z-index: 2;
          @include max-lg {
            display: none;
          }
        }
        &:after {
          content: url('~@assets/images/home/section6-paw-right.svg');;
          position: absolute;
          right: 40px;
          bottom: -80px;
          @include max-lg {
            display: none;
          }
        }
      }
      &__bottomContent {
        background: #FFFFFF;
        box-shadow: 0px 3px 24px rgba(84, 86, 98, 0.1);
        border-radius: 10px;
        margin-top: 30px;
        margin-bottom: 80px;
        padding: 40px 100px;
        @include max-md {
          padding: 24px 36px;
          margin-bottom: 50px;
          font-size: 14px;
        }
      }
    }
  }

}
</style>